// fw TabBar — the fixed bottom navigation PhoneShell renders, exported on
// its own too. Exactly the tabs it is given (Field has three, not
// configurable — spec §2); each tab is a 48px+ target; the active tab is in
// --fw-signal and carries aria-current so state is not colour alone.

import React from 'react';
import { Icon } from '../../components/Icon.js';
import './TabBar.css';

export function TabBar({ items = [], activeKey, onChange, className = '', ...rest }) {
  return (
    <nav className={['fw-tabbar', className].filter(Boolean).join(' ')} aria-label="Primary" {...rest}>
      {items.map((item) => {
        const active = item.key === activeKey;
        return (
          <button
            key={item.key}
            type="button"
            className={['fw-tabbar__tab', active ? 'fw-tabbar__tab--active' : ''].filter(Boolean).join(' ')}
            aria-current={active ? 'page' : undefined}
            data-key={item.key}
            onClick={() => { if (onChange) onChange(item.key); }}
          >
            {item.icon ? <span className="fw-tabbar__icon"><Icon name={item.icon} /></span> : null}
            <span className="fw-tabbar__label">{item.label}</span>
            {item.badge !== undefined && item.badge !== null && item.badge !== 0 && item.badge !== '' ? (
              <span className="fw-tabbar__badge fw-num">{item.badge}</span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}

export default TabBar;
